import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';

import Cleave from '../../components/UI/CustomInputField/CustomCleaveField';
import Button from '../../components/UI/Button/index';
import Message from '../../components/UI/Message';
import Layout from '../../components/Layout/Layout';
import { AnalyticsContext } from '../../ModularReduxAnalytics';
import { AppType } from '../../store/store';

import { useApp } from '../../state/app';
import { useUser, useUserDispatchers } from '../../state/user';
import { TogglesState, useToggles } from '../../state/toggles';

const MIN_AGE = 1;
const MAX_AGE = 110;

interface Props {
  app: AppType;
  history: {
    replace: (route: string) => void;
    push: (route: string) => void;
  };
}

const ChildDOB = ({ history }: Props) => {
  const { tempPhoneNumber, role } = useUser();
  const { setChildDateOfBirth, setUserIsTeen, setNextRegStep } =
    useUserDispatchers();
  const { loading, error, message } = useApp();
  const { analytics } = useContext(AnalyticsContext);
  const toggles: TogglesState = useToggles();

  const [dob, setDob] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.trackEvent('Registration DOB Viewed', {
      eventProps: {
        role: 'child'
      }
    });
    analytics.trackEvent('Feature Toggle Decided', {
      eventProps: {
        feature_key: 'acquisitionfire_kidFirstRegParentInviteV0',
        variation_key: toggles.kidFirstRegParentInviteV0.variationKey,
        toggle_enabled: toggles.kidFirstRegParentInviteV0.enabled,
        experiment_key: 'acquisitionfire_kidFirstRegParentInviteV0_test'
      }
    });

    analytics.trackEvent('Feature Toggle Decided', {
      eventProps: {
        feature_key: 'acquisitionfire_kidFirstRegParentInviteV1',
        variation_key: toggles.kidFirstRegParentInviteV1.variationKey,
        toggle_enabled: toggles.kidFirstRegParentInviteV1.enabled,
        experiment_key: 'acquisitionfire_kidFirstRegParentInviteV1_test'
      }
    });

    if (!tempPhoneNumber) {
      history.replace('/');
    }
  }, []);

  const validAge = (date: string) => {
    const age = moment().diff(moment(date, 'MM/DD/YYYY'), 'years');
    return age >= MIN_AGE && age <= MAX_AGE;
  };

  const isUserATeen = (): boolean => {
    const age = dob
      ? Math.abs(new Date(dob).getUTCFullYear() - new Date().getUTCFullYear())
      : 0;
    return age >= 13 && role === 'child';
  };

  const submitDOB = () => {
    if (!validAge(dob)) {
      setErrorMessage('Please enter a valid date of birth');
      return;
    }

    setErrorMessage('');

    if (setChildDateOfBirth) {
      setChildDateOfBirth({ dob, toggles });
      setUserIsTeen(isUserATeen());
    }
  };

  return (
    <>
      <Message error={error || !!errorMessage} text={message || errorMessage} />
      <Layout>
        <div>
          <h1 data-e2e="dob-header">Your birthday?</h1>
          <div style={{ marginTop: '30px' }}>
            <Cleave
              id="date-of-birth"
              placeholder="Date of birth"
              autoFocus
              options={{
                date: true,
                datePattern: ['m', 'd', 'Y']
              }}
              error={!!errorMessage}
              rawValue={false}
              value={dob}
              format="MM/DD/YYYY"
              secondaryFormat="By entering your birthday, you confirm that the Primary Accountholder is your parent, legal guardian, or trustee."
              inputMode="numeric"
              pattern="[0-9]*"
              onChange={setDob}
              className="fs-mask"
              data-e2e="dob"
            />
            <br />
            <Button
              text="Next"
              loading={loading}
              disabled={dob.length !== 10}
              onClick={submitDOB}
            />
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ChildDOB;
